<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="user-tie"/>
          {{ $t('client') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 alert alert-warning" v-if="$store.state.user.forbidCareTime >= Date.now()">
        Khách chưa được gọi chăm sóc sau 5 phút, bị treo giò cho đến
        {{ $store.state.user.forbidCareTime | moment('DD/MM/YY HH:mm:ss') }}
      </div>
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab>
            <template slot="title">
              {{ $t('all') }}
              <small v-if="!countLoading">({{ count[0] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template slot="title">
              {{ $t('activating') }}
              <small v-if="!countLoading">({{ count[1] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template slot="title">
              {{ $t('expiredSoon') }}
              <small v-if="!countLoading">({{ count[2] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template slot="title">
              {{ $t('expired') }}
              <small v-if="!countLoading">({{ count[3] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template slot="title">
              {{ $t('trial') }}
              <small v-if="!countLoading">({{ count[4] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 5 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('trialExpiredSoon') }}
              <small v-if="!countLoading">({{ count[5] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 6 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('trialExpired') }}
              <small v-if="!countLoading">({{ count[6] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 7 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('locked') }}
              <small v-if="!countLoading">({{ count[7] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 8 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('creditLimit') }}
              <small v-if="!countLoading">({{ count[8] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 9 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('notCared') }}
              <small v-if="!countLoading">({{ count[9] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 10 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('allowDNC') }}
              <small v-if="!countLoading">({{ count[10] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 11 ? 'd-none' : ''">
            <template slot="title">
              Nguồn tự nhiên
              <small v-if="!countLoading">({{ count[11] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 12 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('sourceSalesSelf') }}
              <small v-if="!countLoading">({{ count[12] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 13 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('isCDP') }}
              <small v-if="!countLoading">({{ count[13] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 14 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('affiliated') }}
              <small v-if="!countLoading">({{ count[14] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 15 ? 'd-none' : ''">
            <template slot="title">
              Nguồn marketing
              <small v-if="!countLoading">({{ count[15] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title="$t('lead')" :title-item-class="filterFormModel.status !== 16 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('referralEnabled')"
                 :title-item-class="filterFormModel.status !== 17 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('callUploadFileEnabled')"
                 :title-item-class="filterFormModel.status !== 18 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('multiplePipelineEnabled')"
                 :title-item-class="filterFormModel.status !== 19 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('transcodeMedia')"
                 :title-item-class="filterFormModel.status !== 20 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('offBuyNumber')" :title-item-class="filterFormModel.status !== 21 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('isChatbot')" :title-item-class="filterFormModel.status !== 22 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('bigCustomer')" :title-item-class="filterFormModel.status !== 23 ? 'd-none' : ''"></b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 24 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('isContractPaid') }}
              <small v-if="!countLoading">({{ count[24] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title-item-class="filterFormModel.status !== 25 ? 'd-none' : ''">
            <template slot="title">
              {{ $t('pendingLockAfterActivated') }}
              <small v-if="!countLoading">({{ count[25] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab :title="$t('brandCustomization.tabFilterTitle')"
                 :title-item-class="filterFormModel.status !== 26 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('performanceDiagnosticEnabled')"
                 :title-item-class="filterFormModel.status !== 27 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('evalCallEnabled')"
                 :title-item-class="filterFormModel.status !== 28 ? 'd-none' : ''"></b-tab>
          <b-tab :title="$t('evalChatEnabled')"
                 :title-item-class="filterFormModel.status !== 29 ? 'd-none' : ''"></b-tab>
          <template v-slot:tabs-end>
            <b-dropdown :text="$t('more')" variant="transparent">
              <b-dropdown-item @click="filterFormModel.status = 5">
                {{ $t('trialExpiredSoon') }}
                <small v-if="!countLoading">({{ count[5] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 6">
                {{ $t('trialExpired') }}
                <small v-if="!countLoading">({{ count[6] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 7">
                {{ $t('locked') }}
                <small v-if="!countLoading">({{ count[7] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 8">
                {{ $t('creditLimit') }}
                <small v-if="!countLoading">({{ count[8] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 9" :selected="true">
                {{ $t('notCared') }}
                <small v-if="!countLoading">({{ count[9] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 10" class="active">
                {{ $t('allowDNC') }}
                <small v-if="!countLoading">({{ count[10] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 11" class="active">
                {{ $t('companySource') }}
                <small v-if="!countLoading">({{ count[11] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 12" class="active">
                {{ $t('selfFindingSource') }}
                <small v-if="!countLoading">({{ count[12] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 13" class="active">
                {{ $t('isCDP') }}
                <small v-if="!countLoading">({{ count[13] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 14" class="active">
                {{ $t('affiliated') }}
                <small v-if="!countLoading">({{ count[14] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 15" class="active">
                Nguồn marketing
                <small v-if="!countLoading">({{ count[15] }})</small>
              </b-dropdown-item>
              <b-dropdown-item v-if="checkRole(['admin', 'tech', 'owner', 'account'])"
                               @click="filterFormModel.status = 16" class="active">
                {{ $t('lead') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 17" class="active">
                {{ $t('referralEnabled') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 18" class="active">
                {{ $t('callUploadFileEnabled') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 19" class="active">
                {{ $t('multiplePipelineEnabled') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 20" class="active">
                {{ $t('transcodeMedia') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 21" class="active">
                {{ $t('offBuyNumber') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 22" class="active">
                {{ $t('isChatbot') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 23" class="active">
                {{ $t('bigCustomer') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 24" class="active">
                {{ $t('isContractPaid') }}
                <small v-if="!countLoading">({{ count[24] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 25" class="active">
                {{ $t('pendingLockAfterActivated') }}
                <small v-if="!countLoading">({{ count[25] }})</small>
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 26" class="active">
                {{ $t('brandCustomization.tabFilterTitle') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 27" class="active">
                {{ $t('performanceDiagnosticEnabled') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 28" class="active">
                {{ $t('evalCallEnabled') }}
              </b-dropdown-item>
              <b-dropdown-item @click="filterFormModel.status = 29" class="active">
                {{ $t('evalChatEnabled') }}
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <template v-if="$store.state.user.role !== 'lookup'">
              <host-select class="mr-1 mb-1" :model="filterFormModel" attribute="host"></host-select>
              <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="category"
                           :options="[{ value: null, text: $t('chooseBusinessCategory') }].concat(categoryOptions)"></form-select>
              <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="plan" :options="plans"></form-select>
              <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="partnerDomain"
                           :options="partnerDomainFilterOptions"></form-select>
              <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="sales" :isFilter="true"
                                 :place-holder="$t('chooseBD')" not-updated-select
                                 v-if="checkRole(['owner', 'admin', 'tech', 'account', 'manager', 'supervisor', 'operationsManager', 'salesAssistant', 'am'])">
              </admin-user-select>
              <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="account" :isFilter="true"
                                 :place-holder="$t('chooseAM')" not-updated-select
                                 v-if="checkRole(['owner', 'admin', 'tech', 'account', 'manager', 'supervisor', 'operationsManager', 'salesAssistant', 'am'])">
              </admin-user-select>
              <form-select :model="filterFormModel" attribute="userCount" class="mr-1 mb-1" :options="[
                { value: null, text: $t('filterByUserCount') },
                { value: 'userLimit', text: $t('userLimit') }
              ]"></form-select>
              <b-form-input class="mr-1 mb-1" v-if="filterFormModel.userCount" v-model="filterFormModel.userCountMin"
                            type="number" min="0" :placeholder="$t('userCountMin')"></b-form-input>
              <b-form-input class="mr-1 mb-1" v-if="filterFormModel.userCount" v-model="filterFormModel.userCountMax"
                            type="number" min="0" :placeholder="$t('userCountMax')"></b-form-input>
              <form-select :model="filterFormModel" attribute="source" class="mr-1 mb-1" :options="[
                { value: null, text: $t('chooseSource') },
                { value: 'agency', text: $t('agency') },
                { value: 'introducingAgent', text: $t('introducingAgent') }
              ]" v-if="!checkRole('agency')"></form-select>
              <form-select :model="filterFormModel" attribute="activationTime" class="mr-1 mb-1" :options="[
                { value: null, text: $t('activationTime') },
                { value: 'gte12Months', text: $t('gte12Months') },
                { value: 'lt12Months', text: $t('lt12Months') },
              ]" v-if="!checkRole('agency')"></form-select>
            </template>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <time-range-picker v-if="$store.state.user.role !== 'lookup'" :model="filterFormModel"
                               fromAttribute="expireTimeFrom" toAttribute="expireTimeTo" :label="$t('expireTime')"
                               class="mr-1 mb-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <mass-care v-if="checkRole(['owner', 'admin', 'tech', 'operationsManager'])"></mass-care>
                <change-a-m v-if="checkRole(['owner', 'admin'])"></change-a-m>
                <client-export :filter="filterFormModel" :total-count="itemCount" :category-options="categoryOptions"
                               v-if="checkRole(['owner', 'admin', 'account', 'tech', 'operationsManager', 'manager', 'marketingManager'])"></client-export>
                <button @click="create" class="btn btn-sm btn-success"
                        v-if="checkRole(['owner', 'admin', 'tech', 'account', 'operationsManager'])">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('clientInfo') }}</div>
            <div class="col-lg-3">{{ $t('colStatusTitle') }}</div>
            <div class="col-lg-3">{{ $t('subscribeInfo') }}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id"
               :class="{ 'pd-client-row': item.partnerDomain }"
               :style="item.partnerDomain ? { backgroundColor: '#ede7f6' } : (item.performanceDiagnosticEnabled ? { backgroundColor: '#fff3cd' } : null)">

            <div class="col-lg-3">
              <!-- Nhóm 1: Định danh & Liên hệ -->
              <div class="text-muted small font-weight-bold mb-1">{{ $t('groupIdentity') }}</div>
              <div v-if="checkRole(['owner', 'tech', 'account', 'accountant'])"><b>ID: </b><span>{{ item._id }}</span>
                <font-awesome-icon icon="copy" class="ml-1 text-muted" style="cursor:pointer;font-size:.8em"
                                   :title="$t('copyHint')" @click="copyText(item._id)"/>
              </div>
              <div>
                <b>{{ $t('clientCode') }}: </b>
                <span v-if="item.code">{{ item.code }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div><b>{{ $t('companyName') }}: </b><span>{{ item.companyName }}</span>
                <i v-if="hasBrandCustomization(item)" class="fa fa-paint-brush ml-1"
                   :class="hasBrandData(item) ? 'text-info' : 'text-muted'"
                   :title="hasBrandData(item) ? $t('brandCustomization.hasBrand') : $t('brandCustomization.allowedNotSetup')"
                   style="font-size: 0.9em;"></i>
              </div>
              <div v-if="item.partnerDomain">
                <span class="badge" style="background:#6c5ce7;color:#fff;font-weight:600"
                      :title="$t('partnerDomainAssign')">
                  <font-awesome-icon icon="globe"/> {{ partnerDomainText(item) }}
                </span>
              </div>

              <div><b>{{ $t('email') }}: </b><span>{{ mustHidden(item) ? hideEmail(item) : item.email }}</span></div>
              <div><b>{{ $t('phone') }}: </b><span>{{ mustHidden(item) ? hidePhone(item) : item.phone }}</span></div>

              <div><b>{{ $t('taxCode') }}: </b><span v-if="item.taxCode">{{ item.taxCode }}</span><span v-else
                                                                                                        class="text-secondary small">{{
                  $t('notUpdated')
                }}</span></div>
              <template v-if="$store.state.user.role !== 'lookup'">
                <!-- Nhóm 2: Đăng ký -->
                <div class="text-muted small font-weight-bold mt-2 mb-1">{{ $t('groupRegistration') }}</div>
                <div><b>{{ $t('createTime') }}: </b><span>{{ item.createTime | moment('DD/MM/YY HH:mm:ss') }}</span>
                </div>
                <div v-if="item.source"><b>{{ $t('source') }}: </b><span>{{ $t(item.source) }}</span></div>
                <div>
                  <b>{{ $t('businessCategory') }}: </b>
                  <span v-if="item.category">{{ getBusinessCategory(item.category) }}</span>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>
                <div v-if="item.companySize"><b>{{ $t("companySize") }}: </b><span>{{ item.companySize }}</span></div>
                <div v-if="item.registerRole"><b>{{ $t("registerRole") }}: </b><span>{{ item.registerRole }}</span>
                </div>
                <div v-if="item.useNeed"><b>{{ $t("useNeed") }}: </b><span>{{ item.useNeed.join(", ") }}</span></div>
                <div v-if="item.affiliate">
                  <b>{{ $t('affiliate') }}: </b>
                  <span>{{ `${item.affiliate.companyName} (${item.affiliate.domain})` }}</span>
                </div>
                <div v-if="item.utm_source"><b>Utm Source: </b><span>{{ item.utm_source }}</span></div>
                <div v-if="item.utm_medium"><b>Utm Medium: </b><span>{{ item.utm_medium }}</span></div>
                <div v-if="item.utm_campaign"><b>Utm Campaign: </b><span>{{ item.utm_campaign }}</span></div>
              </template>
            </div>
            <div class="col-lg-3">
              <!-- Nhóm 1: Trạng thái (sức khỏe khách — lên đầu để liếc nhanh) -->
              <div class="text-muted small font-weight-bold mb-1">{{ $t('groupStatus') }}</div>
              <div>
                <span v-if="!item.active" class="badge badge-danger ml-1">{{ $t('locked') }}</span>
                <span v-else-if="item.expireTime >= Date.now() || item.expireTime === 0"
                      class="badge badge-success ml-1">{{
                    $t('activating')
                  }}</span>
                <span v-else class="badge badge-danger ml-1">{{ $t('expired') }}</span>

                <!-- Nguồn khách (3 loại loại trừ nhau) — màu trung tính, không cảnh báo -->
                <span v-if="!item.utm_source" class="badge badge-info ml-1">{{ $t('sourceOrganic') }}</span>
                <span v-else-if="item.utm_source === 'sales'" class="badge badge-info ml-1">{{ $t('sourceSalesSelf') }}</span>
                <span v-else class="badge badge-info ml-1">{{ $t('sourceMarketing') }}</span>


                <span v-if="item.isDemo" class="badge badge-info  ml-1">{{ $t('demo') }}</span>
                <span v-if="item.isTrial" class="badge badge-warning  ml-1">{{ daysLeft(item.expireTime) > 0 ? $t('trialDaysLeft', { days: daysLeft(item.expireTime) }) : $t('isTrial') }}</span>
                <span v-if="!item.isKYC" class="badge badge-warning  ml-1">{{ $t('notKYC') }}</span>
                <span v-if="item.trialExtendRequest" class="badge badge-warning ml-1">{{
                    $t('trialExtendRequest')
                  }}</span>
                <span v-if="item.monthlyUserPackage" class="badge badge-primary ml-1">{{ $t('monthlyUserPackage') }} ({{
                    item.packageLimit
                  }})</span>
                <span v-if="item.betaTestingEnabled" class="badge badge-info ml-1">{{ $t('betaTesting') }}</span>
                <span v-if="item.smsTemplateManageEnabled" class="badge badge-secondary ml-1">{{
                    $t('smsTemplateManageEnabled')
                  }}</span>
                <span v-if="firstOrders[item._id]" class="badge ml-1"
                      :class="getMonthActivated(firstOrders[item._id].confirmTime, mm.endOf('month').valueOf()) >= 12 ? 'badge-pink' : 'badge-blue'">
                  {{
                    getMonthActivated(firstOrders[item._id].confirmTime, mm.endOf('month').valueOf()) >= 12 ?
                        $t('gte12Months')
                        : $t('lt12Months')
                  }}
                </span>
                <span v-if="firstOrders[item._id] && item.userLimit > 15" class="badge badge-primary ml-1">
                  {{ $t('bigCustomer') }}
                </span>

                <span v-if="item.isContractPaid" class="badge badge-success ml-1">{{ $t('isContractPaid') }}</span>
                <span v-else-if="item.startTime && (item.startTime + 7 * 24 * 60 * 60 * 1000) < Date.now()"
                      class="badge badge-danger ml-1">{{ $t('contractOverdue') }}</span>
                <span v-else-if="item.startTime && (item.startTime + 7 * 24 * 60 * 60 * 1000) >= Date.now()"
                      class="badge badge-warning ml-1">{{ $t('contractDaysLeft', { days: Math.ceil(((item.startTime + 7 * 24 * 60 * 60 * 1000) - Date.now()) / (24 * 60 * 60 * 1000)) }) }}</span>
              </div>
              <template v-if="$store.state.user.role !== 'lookup'">
                <!-- Nhóm 2: Phụ trách (ai sở hữu khách) -->
                <div class="text-muted small font-weight-bold mt-2 mb-1">{{ $t('groupOwnership') }}</div>

                <div v-if="!checkRole('agency')">
                  <b>{{ $t('businessDevelopment') }}: </b>
                  <span v-if="item.sales">{{ item.sales.name }}</span>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>
                <div v-if="!checkRole('agency')">
                  <b>{{ $t('accountManagement') }}: </b>
                  <span v-if="item.account">{{ item.account.name }}</span>
                  <span v-else-if="item.active && (item.expireTime === 0 || item.expireTime >= Date.now())"
                        class="badge badge-danger">{{ $t('noAccountWarning') }}</span>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>
                <div v-if="item.agency">
                  <b>{{ $t('agency') }}: </b>
                  <span>{{ item.agency.name }}</span>
                </div>
                <div v-if="firstOrders[item._id]">
                  <b>{{ $t('firstOrderSale') }}: </b><span v-if="firstOrders[item._id].sales">{{
                    firstOrders[item._id].sales.name
                  }}</span>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>
                <div v-if="firstOrders[item._id]">
                  <b>{{ $t('firstOrderValue') }}: </b><span>{{ firstOrders[item._id].total | numFormat }}</span>
                </div>
                <div v-if="firstOrders[item._id]">
                  <b>{{
                      $t('firstOrderTime')
                    }}: </b><span>{{ firstOrders[item._id].confirmTime | moment('DD/MM/YY HH:mm:ss') }}</span>
                </div>
              </template>
              <!-- Nhóm 3: Hạ tầng (IP/domain — kỹ thuật, ít cần liếc nên để cuối) -->
              <div class="text-muted small font-weight-bold mt-2 mb-1">{{ $t('groupInfra') }}</div>
              <div v-if="$store.state.user.role !== 'lookup'"><b>{{ $t('host') }}: </b><span>{{ item.host.ip }}</span>
                <font-awesome-icon icon="copy" class="ml-1 text-muted" style="cursor:pointer;font-size:.8em"
                                   :title="$t('copyHint')" @click="copyText(item.host.ip)"/>
              </div>
              <div><b>{{ $t('domain') }}: </b><span>{{ item.domain }}</span>
                <font-awesome-icon icon="copy" class="ml-1 text-muted" style="cursor:pointer;font-size:.8em"
                                   :title="$t('copyHint')" @click="copyText(item.domain)"/>
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <span>{{ $t('plan') }}: </span>
                <span v-if="item.privatePlan" class="text-danger">{{ $t('privatePlan') }}</span>
                <span v-else-if="item.plan">{{ item.plan.name }}</span>
                <span v-else class="text-danger">{{ $t('na') }}</span>
              </div>
              <div v-if="item.privatePlan && $store.state.user.role !== 'lookup'">
                <div>
                  <span>{{ $t('userPrice') }}: </span>
                  <span>{{ item.userPrice | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <span>{{ $t('channelPrice') }}: </span>
                  <span>{{ item.channelPrice | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <span>{{ $t('advancedNumber') }}: </span>
                  <span>{{ item.advancedNumber | numFormat }}</span>
                </div>
                <div>
                  <span>{{ $t('channelNumber') }}: </span>
                  <span>{{ item.channelNumber | numFormat }}</span>
                </div>
                <div>
                  <span>{{ $t('numberLimit') }}: </span>
                  <span>{{ item.numberLimit | numFormat }}</span>
                </div>
                <div>
                  <span>{{ $t('socialNetworkAccountLimit') }}: </span>
                  <span>{{ item.socialNetworkAccountLimit | numFormat }}</span>
                </div>
                <!-- Tính năng gói riêng: gom chip (bỏ badge đỏ báo động) -->
                <div class="mt-2">
                  <div class="text-muted small mb-1">{{ $t('subscribeFeatureEnabled') }}:</div>
                  <template v-if="featureChips(item, planFlagsA).some(f => f.on)">
                    <span v-for="f in featureChips(item, planFlagsA).filter(f => f.on)" :key="'a-on-' + f.label"
                          class="badge badge-success mr-1 mb-1">{{ f.label }}</span>
                  </template>
                  <span v-else class="badge badge-light border text-muted mb-1">{{ $t('subscribeFeatureNone') }}</span>
                  <template v-if="featureChips(item, planFlagsA).some(f => !f.on)">
                    <div v-if="featureExpanded[item._id + ':a']" class="mt-1">
                      <span v-for="f in featureChips(item, planFlagsA).filter(f => !f.on)" :key="'a-off-' + f.label"
                            class="badge badge-light border text-muted mr-1 mb-1">{{ f.label }}</span>
                    </div>
                    <div>
                      <a href="javascript:void(0)" class="small text-muted text-decoration-none" @click="toggleFeature(item._id, 'a')">
                        {{ featureExpanded[item._id + ':a'] ? '▴ ' + $t('collapseFeature') : '▾ ' + featureChips(item, planFlagsA).filter(f => !f.on).length + ' ' + $t('featureOffSuffix') }}
                      </a>
                    </div>
                  </template>
                </div>
                <div>
                  <span>{{ $t('videoCCUPrice') }}: </span>
                  <span>{{ item.videoCCUPrice | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <span>{{ $t('videoRecordingPrice') }}: </span>
                  <span>{{ item.videoCCURecordingPrice | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <span>{{ $t('videoCCUNumber') }}: </span>
                  <span>{{ item.videoCCUNumber | numFormat }}</span>
                </div>
                <hr/>
              </div>
              <div>
                <span>{{ $t('expireTime') }}: </span>
                <span v-if="item.expireTime">{{ item.expireTime | moment('DD/MM/YY HH:mm:ss') }}</span>
                <span v-if="item.expireTime === 0">{{ $t('noExpireTime') }}</span>
              </div>
              <div><span>{{ $t('numberOfUser') }}: </span><span>{{ item.userCount }}/{{ item.userLimit }}</span></div>
              <template v-if="$store.state.user.role !== 'lookup'">
                <div>
                  <span>{{ $t('creditBalance') }}: </span>
                  <span :class="{ 'text-danger font-weight-bold': item.creditBalance < 0 }">{{ item.creditBalance | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <span>{{ $t('creditLimit') }}: </span>
                  <span>{{ item.creditLimit | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <span>{{ $t('baseCallFee') }}: </span>
                  <span>{{ (item.baseCallFee || 0) | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div v-if="item.averageDailyExpense">
                  <span>{{ $t('averageDailyExpense') }}: </span>
                  <span>{{ item.averageDailyExpense | numFormat }} {{
                      item.country.currency
                    }} ({{ item.averageDailyExpenseLastUpdateTime | moment('DD/MM/YY HH:mm:ss') }})</span>
                </div>
                <!-- Tính năng đang bật: gom chip xanh, cái tắt thu gọn (bỏ badge đỏ báo động) -->
                <div class="mt-2">
                  <div class="text-muted small mb-1">{{ $t('subscribeFeatureEnabled') }}:</div>
                  <template v-if="featureChips(item, planFlagsB).some(f => f.on)">
                    <span v-for="f in featureChips(item, planFlagsB).filter(f => f.on)" :key="'b-on-' + f.label"
                          class="badge badge-success mr-1 mb-1">{{ f.label }}</span>
                  </template>
                  <span v-else class="badge badge-light border text-muted mb-1">{{ $t('subscribeFeatureNone') }}</span>
                  <template v-if="featureChips(item, planFlagsB).some(f => !f.on)">
                    <div v-if="featureExpanded[item._id + ':b']" class="mt-1">
                      <span v-for="f in featureChips(item, planFlagsB).filter(f => !f.on)" :key="'b-off-' + f.label"
                            class="badge badge-light border text-muted mr-1 mb-1">{{ f.label }}</span>
                    </div>
                    <div>
                      <a href="javascript:void(0)" class="small text-muted text-decoration-none" @click="toggleFeature(item._id, 'b')">
                        {{ featureExpanded[item._id + ':b'] ? '▴ ' + $t('collapseFeature') : '▾ ' + featureChips(item, planFlagsB).filter(f => !f.on).length + ' ' + $t('featureOffSuffix') }}
                      </a>
                    </div>
                  </template>
                </div>
                <div v-if="item.offBuyNumber" class="mt-2">
                  <span class="badge badge-warning">{{ $t('offBuyNumber') }}</span>
                </div>
                <div v-if="item.isChatbot">
                  <div>
                    <span>{{ $t('aiAgentFreeTokenRemaining') }}: </span>
                    <span>{{ (item.aiAgentFreeTokenRemaining || 0) | numFormat }} / {{ (item.aiAgentFreeTokenInitial || 0) | numFormat }}</span>
                  </div>
                </div>

              </template>
            </div>
            <div class="col-lg-3">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <info-modal v-if="!checkRole(['marketing', 'marketingManager'])" :client="item"></info-modal>
                    <template v-if="$store.state.user.role !== 'lookup'">
                      <button v-if="checkRole(['owner','admin','tech','operationsManager','sales','salesAssistant','account','accountant','am','manager','supervisor','ctvSales'])"
                              @click="$refs.kycRequestCreate.open(item._id)"
                              type="button"
                              class="btn btn-sm btn-outline-success is-border-1 mr-1"
                              :title="$t('kycRequest.create')">
                        <font-awesome-icon icon="file-signature"/>&nbsp;{{ $t('kycRequest.create') }}
                      </button>
                      <trial-extend-request :client="item"
                                            v-if="item.isTrial && !item.trialExtendRequest && !checkRole(['ctvSales'])"></trial-extend-request>
                      <button @click="care(item._id)" type="button" class="btn btn-sm btn-danger mr-1"
                              v-if="(!item.sales || !item.account) && ((item.sales && $store.state.user.role === 'am'))">
                        <!-- ($store.state.user.role === 'sales' && !item.sales) -->
                        <font-awesome-icon icon="heart"/>&nbsp;{{ $t('care') }}
                      </button>

                      <button v-if="!item.isDemo && item.sales && !checkRole(['ctvSales'])" @click="demo(item._id)" type="button"
                              class="btn btn-sm btn-warning mr-1">
                        <i class="fa fa-check-circle-o"></i>
                        {{ $t('isDemo') }}
                      </button>
                    </template>
                  </div>
                  <div class="c-buttons__col"
                       v-if="checkRole(['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am', 'sales', 'kpiSales', 'manager'])">
                    <button
                        v-if="checkRole(['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'manager']) || (checkRole(['am']) && item.account && item.account._id === $store.state.user._id) || (checkRole(['sales', 'kpiSales']) && item.sales && item.sales._id === $store.state.user._id)"
                        @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <divide
                        v-if="!item.isTrial && checkRole(['owner', 'admin', 'tech', 'account', 'operationsManager'])"
                        :client-to-divide="item._id"></divide>
                  </div>
                  <template v-if="$store.state.user.role !== 'lookup' && !checkRole(['ctvSales'])">
                    <div class="c-buttons__col" v-if="$store.state.user.role !== 'agency'">
                      <monthly-user-new :client="item._id" v-if="!item.isPackage"></monthly-user-new>
                      <monthly-user-more :client="item._id" v-if="item.isPackage"></monthly-user-more>
                      <monthly-user-extend :client="item._id" v-if="item.isPackage"></monthly-user-extend>
                    </div>
                    <div class="c-buttons__col">
                      <buy-new :clientId="item._id"
                               v-if="$store.state.user.role !== 'agency' && (item.isTrial || (item.plan && item.plan.unlimitedUser))"></buy-new>
                      <buy-user :clientId="item._id"
                                v-if="!item.isTrial && item.plan && !item.plan.unlimitedUser"></buy-user>
                      <extend :client-id="item._id" v-if="!item.isTrial && item.plan && !item.plan.unlimitedUser">
                      </extend>
                      <!--                                        <unlimited :client-id="item._id" v-if="item.plan && !item.plan.unlimitedUser"></unlimited>-->
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" size="xl" no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-md">
          <div v-if="taxCodeWarning" class="alert alert-warning py-1 px-2 small">{{ taxCodeWarning }}</div>
          <form-input :label="$t('companyName')" :model="formModel" attribute="companyName" :errors="formErrors"
                      :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])">
          </form-input>
          <form-input :label="$t('taxCode')" :model="formModel" attribute="taxCode" :errors="formErrors"
                      :disabled="checkRole(['accountant'])" @change="searchCompanyCode">
          </form-input>
          <form-input :label="$t('email')" :model="formModel" attribute="email" :errors="formErrors"
                      :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])">
          </form-input>
          <form-input :label="$t('phone')" :model="formModel" attribute="phone" :errors="formErrors"
                      :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])">
          </form-input>
          <country-select :model="formModel" :errors="formErrors" :disabled="formModel.id ? true : false"
                          :label="$t('country')"></country-select>
          <form-select :model="formModel" :options="timezoneOptions" :disabled="!formModel.country || formModel.id"
                       attribute="timezone" :label="$t('timezone')" :errors="formErrors"></form-select>
          <host-select :model="formModel" countryAttribute="country" type="client" :errors="formErrors"
                       :label="$t('host')"
                       :disabled="!formModel.country || checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])">
          </host-select>
          <form-input :label="$t('domain')" :model="formModel" attribute="domain" :errors="formErrors"
                      :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])">
          </form-input>
          <form-input label="Utm Source" :model="formModel" attribute="utm_source" :errors="formErrors"
                      v-if="checkRole(['owner', 'tech'])">
          </form-input>
        </div>
        <div class="col-md">
          <form-select :label="$t('plan')" :model="formModel" attribute="plan" :errors="formErrors" :options="plans"
                       :disabled="formModel.country === null || !(checkRole(['owner', 'tech'])) || (!formModel.isTrial && !checkRole('owner'))">
          </form-select>
          <form-date-time :label="$t('expireTime')" :model="formModel" attribute="expireTime" :errors="formErrors"
                          format="D MMMM YYYY" :disabled="true"></form-date-time>
          <form-input :label="$t('userLimit')" :model="formModel" attribute="userLimit" :errors="formErrors"
                      :disabled="formModel.id">
          </form-input>
          <form-input :label="$t('creditLimit')" :model="formModel" attribute="creditLimit"
                      :disabled="!checkRole(['owner', 'admin', 'operationsManager', 'account'])"
                      :errors="formErrors"></form-input>
          <form-date-time :label="$t('careTime')" :model="formModel" attribute="careTime"
                          :disabled="!checkRole(['owner', 'admin', 'operationsManager', 'tech'])"
                          :errors="formErrors"></form-date-time>
          <div>
            <admin-user-select :model="formModel" attribute="sales" :errors="formErrors"
                               :label="$t('businessDevelopment')"
                               v-if="!checkRole(['agency', 'am', 'sales', 'kpiSales', 'accountant']) && formModel.country"
                               place-holder="Business development"></admin-user-select>
            <admin-user-select :model="formModel" attribute="account" :errors="formErrors"
                               :label="$t('accountManagement')"
                               v-if="!checkRole(['agency', 'am', 'sales', 'kpiSales', 'manager', 'accountant']) && formModel.country"
                               place-holder="Account management"></admin-user-select>
            <admin-user-select :model="formModel" attribute="agency" :errors="formErrors" :label="$t('agency')"
                               v-if="!checkRole(['agency', 'am', 'sales', 'kpiSales', 'manager', 'accountant']) && formModel.country"
                               :place-holder="$t('chooseAgency')"></admin-user-select>
            <form-select :model="formModel" attribute="partnerDomain" :errors="formErrors" :label="$t('partnerDomainAssign')"
                         v-if="!checkRole(['agency', 'am', 'sales', 'kpiSales', 'manager', 'accountant'])"
                         :options="partnerDomainOptions"></form-select>
            <form-select :model="formModel" attribute="source" :errors="formErrors" :label="$t('source')" :options="[
              { value: null, text: $t('chooseSource') },
              { value: 'agency', text: $t('agency') },
              { value: 'introducingAgent', text: $t('introducingAgent') }
            ]" :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])">
            </form-select>
            <form-input :label="$t('baseCallFee')" :model="formModel" attribute="baseCallFee" :errors="formErrors"
                        :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])">
            </form-input>
          </div>
        </div>
        <div class="col-md">
          <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])"/>
          <form-checkbox :chk-label="$t('isKYC')" :model="formModel" attribute="isKYC" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'accountant'])"/>
          <form-checkbox :chk-label="$t('isTrial')" :model="formModel" attribute="isTrial" :disabled="true"
                         :errors="formErrors">
          </form-checkbox>
          <form-checkbox :chk-label="$t('isDemo')" :model="formModel" attribute="isDemo" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'accountant'])">
          </form-checkbox>
          <form-checkbox :chk-label="$t('allowDNC')" :model="formModel" attribute="allowDNC"
                         v-if="!checkRole(['agency', 'accountant'])" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])"></form-checkbox>
          <form-checkbox :chk-label="$t('allowMultipleLogins')" :model="formModel" attribute="allowMultipleLogins"
                         v-if="!checkRole('agency')" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'accountant'])"></form-checkbox>
          <form-checkbox :chk-label="$t('smsTemplateManageEnabled')" :model="formModel"
                         attribute="smsTemplateManageEnabled" v-if="!checkRole(['agency', 'accountant'])"
                         :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager'])"></form-checkbox>
          <form-checkbox chk-label="Beta testing" :model="formModel" attribute="betaTestingEnabled"
                         v-if="!checkRole(['agency', 'accountant'])" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager'])"></form-checkbox>
          <form-checkbox :chk-label="$t('ssoEnabled')" :model="formModel" attribute="ssoEnabled" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])"></form-checkbox>

          <form-checkbox :chk-label="$t('mediaRelay')" :model="formModel" attribute="mediaRelay" :errors="formErrors"
                         :disabled="checkRole(['am', 'sales', 'kpiSales', 'manager', 'accountant'])"></form-checkbox>

          <form-checkbox :chk-label="$t('customerContactEnabled')" :model="formModel" attribute="customerContactEnabled"
                         v-if="checkRole(['admin', 'tech', 'owner'])" :errors="formErrors"></form-checkbox>
          <form-checkbox :chk-label="$t('subscribeEmail')" :model="formModel" attribute="subscribeEmail"
                         v-if="checkRole(['admin', 'tech', 'owner', 'am', 'sales', 'kpiSales', 'manager'])"
                         :errors="formErrors"/>

          <form-checkbox :chk-label="$t('offBuyNumber')" :model="formModel" attribute="offBuyNumber"
                         v-if="checkRole(['admin', 'tech', 'owner', 'am', 'sales', 'kpiSales', 'manager', 'account'])"
                         :errors="formErrors"/>

          <form-checkbox :chk-label="$t('manualInvoiceEnabled')" :model="formModel" attribute="manualInvoiceEnabled"
                         v-if="checkRole(['owner'])" :errors="formErrors"></form-checkbox>
          <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('callUploadFileEnabled')" :model="formModel"
                         attribute="callUploadFileEnabled" :errors="formErrors"></form-checkbox>
          <form-checkbox :disabled="!checkRole(['owner', 'tech'])" :chk-label="$t('referralEnabled')" :model="formModel"
                         attribute="referralEnabled" :errors="formErrors"></form-checkbox>
          <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('transcodeMedia')" :model="formModel"
                         attribute="transcodeMedia" :errors="formErrors"></form-checkbox>
          <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('multiplePipelineEnabled')" :model="formModel"
                         attribute="multiplePipelineEnabled" :errors="formErrors"></form-checkbox>
          <form-checkbox :disabled="!checkRole(['owner', 'tech'])" :chk-label="$t('performanceDiagnosticEnabled')" :model="formModel"
                         attribute="performanceDiagnosticEnabled" :errors="formErrors"></form-checkbox>

          <form-checkbox-group :model="formModel" :label="$t('chooseBusinessCategory')" attribute="category"
                               :stacked="true" :errors="formErrors" :options="categoryOptions"
                               :disabled="checkRole(['accountant'])">
          </form-checkbox-group>

          <form-checkbox v-if="checkRole(['owner', 'admin', 'tech', 'account', 'accountant'])"
                         :chk-label="$t('isContractPaid')" :model="formModel" attribute="isContractPaid"
                         :errors="formErrors"></form-checkbox>
        </div>
      </div>
      <form-checkbox :chk-label="$t('privatePlan')" :model="formModel" attribute="privatePlan"
                     :disabled="!checkRole(['owner'])" v-if="!checkRole('agency')" :errors="formErrors"></form-checkbox>
      <div v-if="formModel.privatePlan && !checkRole('agency')">
        <div class="row">
          <div class="col-md">
            <form-input :disabled="!checkRole(['owner'])" :label="$t('userPrice')" :model="formModel"
                        attribute="userPrice" :errors="formErrors"/>
            <form-input :disabled="!checkRole(['owner'])" :label="$t('channelNumber')" :model="formModel"
                        attribute="channelNumber" :errors="formErrors"/>
            <form-input :disabled="!checkRole(['owner'])" :label="$t('numberLimit')" :model="formModel"
                        attribute="numberLimit" :errors="formErrors"/>
            <form-input :disabled="!checkRole(['owner'])" :label="$t('automationWorkflowLimit')" :model="formModel"
                        attribute="automationWorkflowLimit" :errors="formErrors" :placeholder="$t('unlimitedIfEmpty')"/>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('callEnabled')" :model="formModel"
                           attribute="callEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('multiChannelEnabled')" :model="formModel"
                           attribute="multiChannelEnabled" :errors="formErrors"></form-checkbox>
          </div>
          <div class="col-md">
            <form-input :disabled="!checkRole(['owner'])" :label="$t('channelPrice')" :model="formModel"
                        attribute="channelPrice" :errors="formErrors"/>
            <form-input :disabled="!checkRole(['owner'])" :label="$t('advancedNumber')" :model="formModel"
                        attribute="advancedNumber" :errors="formErrors"/>
            <form-input :disabled="!checkRole(['owner'])" :label="$t('socialNetworkAccountLimit')" :model="formModel"
                        attribute="socialNetworkAccountLimit" :errors="formErrors"/>
            <form-input :disabled="!checkRole(['owner'])" :label="$t('automationLimit')" :model="formModel"
                        attribute="automationLimit" :errors="formErrors" :placeholder="$t('unlimitedIfEmpty')"/>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('callCampaignEnabled')" :model="formModel"
                           attribute="callCampaignEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('pipelineEnabled')" :model="formModel"
                           attribute="pipelineEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('kpiEnabled')" :model="formModel"
                           attribute="kpiEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('ticketEnabled')" :model="formModel"
                           attribute="ticketEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('aiEnabled')" :model="formModel"
                           attribute="aiEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('orderEnabled')" :model="formModel"
                           attribute="orderEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox :disabled="!checkRole(['owner'])" :chk-label="$t('integrationEnabled')" :model="formModel"
                           attribute="integrationEnabled" :errors="formErrors"></form-checkbox>
            <form-checkbox v-if="formModel.callEnabled" :disabled="!checkRole(['owner'])"
                           :chk-label="$t('videoEnabled')" :model="formModel" attribute="videoEnabled"
                           :errors="formErrors"></form-checkbox>
          </div>
        </div>
        <template v-if="formModel.callEnabled && formModel.videoEnabled">
          <div class="row">
            <form-input class="col-md" :disabled="!checkRole(['owner'])" :label="$t('videoCCUPrice')" :model="formModel"
                        attribute="videoCCUPrice" :errors="formErrors"/>
            <form-input class="col-md" :disabled="!checkRole(['owner'])" :label="$t('videoRecordingPrice')"
                        :model="formModel" attribute="videoCCURecordingPrice" :errors="formErrors"/>
            <form-input class="col-md" :disabled="!checkRole(['owner'])" :label="$t('videoCCUNumber')"
                        :model="formModel" attribute="videoCCUNumber" :errors="formErrors"/>
          </div>
        </template>
      </div>
      <div class="row"
           v-if="formModel._id && !checkRole(['agency', 'am', 'sales', 'kpiSales', 'manager', 'accountant'])">
        <div class="col">
          <form-checkbox :chk-label="$t('updateAllUsers')" :model="formModel" attribute="allUsers"
                         :errors="formErrors"></form-checkbox>
        </div>
      </div>
      <form-checkbox :chk-label="$t('isChatbot')" :model="formModel" attribute="isChatbot"
                     :disabled="!checkRole(['owner'])" :errors="formErrors"></form-checkbox>
      <div v-if="formModel.isChatbot && checkRole('owner')">
        <small class="text-muted d-block mb-2">{{ $t('aiAgentFreeTokenHint') }}</small>
        <div class="row">
          <form-input class="col-4" type="number" :label="$t('aiAgentFreeTokenInitial')" :model="formModel"
                      attribute="aiAgentFreeTokenInitial" :errors="formErrors"
                      :placeholder="$t('aiAgentFreeTokenInitial')"></form-input>
          <form-input class="col-4" type="number" :label="$t('aiAgentFreeTokenRemaining')" :model="formModel"
                      attribute="aiAgentFreeTokenRemaining" :errors="formErrors"
                      :placeholder="$t('aiAgentFreeTokenRemaining')"></form-input>
        </div>

        <!-- ===== Gói AI Token v2 (chốt 2026-06-05) ===== -->
        <hr class="my-3"/>
        <h6 class="mb-2"><i class="fa fa-cube text-primary"></i> {{ $t('aiAgentPackage.title') }}</h6>
        <small class="text-muted d-block mb-2">{{ $t('aiAgentPackage.hint') }}</small>

        <div class="row">
          <form-select class="col-4" :label="$t('aiAgentPackage.package')" :model="formModel"
                       attribute="aiAgentPackage" :options="aiAgentPackageOptions" :errors="formErrors"/>
          <form-input class="col-4" type="number" :label="$t('aiAgentPackage.capToken')" :model="formModel"
                      attribute="aiAgentPackageCapToken" :errors="formErrors"
                      :description="$t('aiAgentPackage.capTokenHint')"/>
          <form-input class="col-4" type="number" :label="$t('aiAgentPackage.usedThisPeriod')" :model="formModel"
                      attribute="aiAgentPackageTokenUsedThisPeriod" :errors="formErrors"
                      :description="$t('aiAgentPackage.usedHint')"/>
        </div>

        <div class="row">
          <div class="col-6">
            <label class="d-block mb-1">{{ $t('aiAgentPackage.whenCapExhausted') }}</label>
            <div class="form-check mb-1">
              <input class="form-check-input" type="radio" id="capPause" value="pause"
                     v-model="formModel.aiAgentPackageWhenCapExhausted"/>
              <label class="form-check-label" for="capPause">
                <b>{{ $t('aiAgentPackage.pause') }}</b>
                <small class="text-muted d-block">{{ $t('aiAgentPackage.pauseHint') }}</small>
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" id="capFallback" value="fallback"
                     v-model="formModel.aiAgentPackageWhenCapExhausted"/>
              <label class="form-check-label" for="capFallback">
                <b>{{ $t('aiAgentPackage.fallback') }}</b>
                <small class="text-muted d-block">{{ $t('aiAgentPackage.fallbackHint') }}</small>
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="alert alert-light border small mb-0" v-if="formModel.aiAgentPackage">
              <div><b>Chat:</b> {{ (formModel.aiAgentPackageTokenUsedChat || 0) | numFormat }} token</div>
              <div><b>QA:</b> {{ (formModel.aiAgentPackageTokenUsedQa || 0) | numFormat }} token</div>
              <div v-if="formModel.aiAgentPackageNextResetTime">
                <b>{{ $t('aiAgentPackage.nextReset') }}:</b>
                {{ moment(formModel.aiAgentPackageNextResetTime).format('DD/MM/YYYY HH:mm') }}
              </div>
              <div class="text-muted mt-1" style="font-size: 11px;">
                {{ $t('aiAgentPackage.resetNote') }}
              </div>
            </div>
            <div v-else class="alert alert-light border small mb-0 text-muted">
              {{ $t('aiAgentPackage.noPackage') }}
            </div>
          </div>
        </div>
      </div>
      <hr v-if="checkRole(['owner'])"/>
      <form-checkbox v-if="checkRole(['owner'])"
                     :chk-label="$t('brandCustomization.adminToggleLabel')"
                     :model="formModel" attribute="brandCustomizationEnabled"
                     :errors="formErrors"></form-checkbox>
      <small v-if="checkRole(['owner'])" class="text-muted d-block mb-2">{{ $t('brandCustomization.adminToggleHint') }}</small>
      <div v-if="formModel.brandCustomizationEnabled && formModel.brandCustomization" class="brand-preview p-3 mb-2"
           style="background: #f8f9fa; border-radius: 4px;">
        <strong class="d-block mb-2">{{ $t('brandCustomization.preview') }}</strong>
        <div class="row">
          <div class="col-6">
            <div class="mb-2">
              <small class="text-muted d-block">{{ $t('brandCustomization.logo') }}</small>
              <img v-if="formModel.brandCustomization.logo" :src="formModel.brandCustomization.logo" style="max-height: 40px; max-width: 180px; object-fit: contain;" />
              <span v-else class="text-muted">—</span>
            </div>
            <div>
              <small class="text-muted d-block">{{ $t('brandCustomization.favicon') }}</small>
              <img v-if="formModel.brandCustomization.favicon" :src="formModel.brandCustomization.favicon" style="width: 32px; height: 32px; object-fit: contain;" />
              <span v-else class="text-muted">—</span>
            </div>
          </div>
          <div class="col-6">
            <div v-for="key in ['primaryColor', 'secondaryColor', 'sidebarBgColor', 'headerBgColor']" :key="key" class="mb-1">
              <small class="text-muted d-inline-block" style="width: 130px;">{{ $t('brandCustomization.' + key) }}:</small>
              <span v-if="formModel.brandCustomization[key]" class="d-inline-block align-middle"
                    :style="{ background: formModel.brandCustomization[key], width: '20px', height: '20px', border: '1px solid #ddd', verticalAlign: 'middle' }"></span>
              <span class="ml-1">{{ formModel.brandCustomization[key] || '—' }}</span>
            </div>
          </div>
        </div>
        <small v-if="formModel.brandCustomization.updatedTime" class="text-muted d-block mt-2">
          {{ $t('brandCustomization.updatedAt') }}: {{ moment(formModel.brandCustomization.updatedTime).format('DD/MM/YYYY HH:mm') }}
          <span v-if="formModel.populatedBrandUpdatedBy">
            | {{ $t('brandCustomization.updatedBy') }}: {{ formModel.populatedBrandUpdatedBy.name || formModel.populatedBrandUpdatedBy.email }}
          </span>
        </small>
      </div>
    </b-modal>
    <k-y-c-request-create-modal ref="kycRequestCreate" @open-existing="goToKycRequest" />
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import TaxCodeLookup from "../../mixins/TaxCodeLookup";
import _ from 'lodash';
import HostSelect from "../../components/HostSelect";
import CountrySelect from "../../components/CountrySelect";
import ClientExport from "./ClientExport";
import TimeRangePicker from "../../components/TimeRangePicker";
import AdminUserSelect from "../../components/AdminUserSelect";
import Divide from "./Divide";
import MonthlyUserNew from "../finance/client-package/MonthlyUserNew";
import MonthlyUserMore from "../finance/client-package/MonthlyUserMore";
import MonthlyUserExtend from "../finance/client-package/MonthlyUserExtend";
import BuyNew from "@/views/finance/plan-order/BuyNew";
import BuyUser from "@/views/finance/plan-order/BuyUser";
import Extend from "@/views/finance/plan-order/Extend";
import TrialExtendRequest from "@/views/client/TrialExtendRequest";
import ChangeAM from "@/views/client/ChangeRole.vue";
import store from "@/store";
import MassCare from './MassCare';
import InfoModal from './InfoModal';
import KYCRequestCreateModal from './kyc-request/KYCRequestCreateModal.vue';
import moment from 'moment'

export default {
  components: {
    MassCare,
    TrialExtendRequest, Extend,
    BuyNew, BuyUser, Divide,
    MonthlyUserExtend, MonthlyUserMore, MonthlyUserNew,
    TimeRangePicker, ChangeAM, InfoModal, KYCRequestCreateModal,
    ClientExport, CountrySelect, HostSelect, AdminUserSelect
  },
  mixins: [List, CRUD, TaxCodeLookup],
  data: function () {
    return {
      moment,
      taxCodeWarning: null,
      service: '/client',
      afterLoad: () => {
        this.getCount();
        this.getFistOrder();
      },
      defaultFormModel: {
        companyName: null,
        taxCode: null,
        category: [],
        email: null,
        phone: null,
        host: null,
        domain: null,
        expireTime: Date.now() + 14 * 24 * 60 * 60 * 1000,
        privatePlan: false,
        active: true,
        plan: null,
        country: null,
        userLimit: 0,
        creditLimit: 0,
        timezone: null,
        isTrial: true,
        source: null,
        sales: null,
        account: null,
        partnerDomain: null,
        baseCallFee: 0,
        backupHost: null,
        mediaRelay: null,
        isDemo: false,
        ssoEnabled: true,
        customerContactEnabled: false,
        performanceDiagnosticEnabled: false,
        callEnabled: false,
        videoEnabled: false,
        callUploadFileEnabled: false,
        isChatbot: false,
        aiAgentFreeTokenInitial: 0,
        aiAgentFreeTokenRemaining: 0,
        // AI Token v2 (chốt 2026-06-05)
        aiAgentPackage: null,
        aiAgentPackageCapToken: 0,
        aiAgentPackageTokenUsedThisPeriod: 0,
        aiAgentPackageTokenUsedChat: 0,
        aiAgentPackageTokenUsedQa: 0,
        aiAgentPackageNextResetTime: 0,
        aiAgentPackageWhenCapExhausted: 'fallback',
        isContractPaid: false,
        brandCustomizationEnabled: false,
      },
      reloadBus: 'loadClient',
      defaultFilterFormModel: {
        host: null,
        source: null,
        category: null,
        plan: null,
        partnerDomain: null,
        sales: null,
        account: this.$store.state.user.role === 'am' ? this.$store.state.user._id : null,
        userCount: null,
        userCountMin: 0,
        userCountMax: 100,
        activationTime: null
      },
      plans: [],
      partnerDomains: [],
      timezoneOptions: [],
      categoryOptions: [],
      hosts: [],
      currentHost: null,
      firstOrders: {},
      count: {},
      countLoading: true,
      mm: moment(),
      // Mở/đóng danh sách tính năng đang tắt, key = `${item._id}:${block}`
      featureExpanded: {},
      // Cờ tính năng block "Thông tin gói cước" (luôn hiện)
      planFlagsB: [
        'allowDNC', 'allowMultipleLogins', 'ssoEnabled', 'customerContactEnabled',
        'manualInvoiceEnabled', 'callUploadFileEnabled', 'referralEnabled',
        'transcodeMedia', 'multiplePipelineEnabled', 'subscribeEmail', 'isChatbot',
      ],
      // Cờ tính năng block gói riêng (privatePlan)
      planFlagsA: [
        'callEnabled', 'multiChannelEnabled', 'kpiEnabled', 'ticketEnabled',
        'integrationEnabled', 'performanceDiagnosticEnabled', 'evalCallEnabled',
        'evalChatEnabled', 'aiEnabled', 'callCampaignEnabled', 'pipelineEnabled',
        'orderEnabled', 'phonebookEnabled', 'videoEnabled',
      ],
    }
  },
  mounted() {
    this.$bgService.get('/host', {params: {page: 1, pageSize: 1000}}).then(response => {
      this.hosts = response.data.docs;
    });
    this.getBusinessCategoryList();
    this.getPlans();
    if (this.checkRole(['owner', 'admin', 'tech'])) this.getPartnerDomains();
    // Mở từ "Domain đối tác" (?partnerDomain=<id>) → lọc sẵn khách của đối tác
    if (this.$route.query && this.$route.query.partnerDomain) {
      this.filterFormModel.partnerDomain = this.$route.query.partnerDomain;
      this.load();
    }
  },
  computed: {
    aiAgentPackageOptions() {
      // 4 gói chốt 2026-06-05 + option "Không có gói"
      return [
        { value: null, text: this.$t('aiAgentPackage.noPackageOption') },
        { value: 'basic',    text: 'Basic — 200.000đ / 1M token' },
        { value: 'starter',  text: 'Starter — 1.900.000đ / 10M token (-5%)' },
        { value: 'pro',      text: 'Pro — 3.600.000đ / 20M token (-10%)' },
        { value: 'ultimate', text: 'Ultimate — 7.650.000đ / 45M token (-15%)' },
      ];
    },
    // Domain đối tác: option cho form (gán) — đầu là "không gán"
    partnerDomainOptions() {
      return [{ value: null, text: this.$t('partnerDomainNone') }].concat(
        this.partnerDomains.map(d => ({ value: d._id, text: d.name + ' (' + d.domain + ')' }))
      );
    },
    // Domain đối tác: option cho filter — đầu là "tất cả"
    partnerDomainFilterOptions() {
      return [{ value: null, text: this.$t('partnerDomainAll') }].concat(
        this.partnerDomains.map(d => ({ value: d._id, text: d.name + ' (' + d.domain + ')' }))
      );
    },
  },
  methods: {
    async searchCompanyCode() {
      this.taxCodeWarning = null;
      if (!this.formModel.taxCode || !this.formModel.taxCode.trim()) {
        return;
      }
      const result = await this.lookupTaxCode(this.formModel.taxCode);
      if (!result.ok) {
        this.taxCodeWarning = result.message;
        return;
      }
      if (!this.formModel.companyName && result.data.name) {
        this.$set(this.formModel, 'companyName', result.data.name);
      }
      this.taxCodeWarning = this.taxStatusWarning(result.data);
    },
    // Trả về danh sách cờ tính năng dạng [{label, on}] từ list field name.
    // Dùng cho block "Thông tin gói cước" để gom chip thay vì 13 dòng badge đỏ/xanh.
    featureChips(item, fields) {
      if (!item) return [];
      return fields.map(f => ({ label: this.$t(f), on: !!item[f] }));
    },
    // Toggle mở/đóng nhóm tính năng đang tắt cho 1 row + 1 block
    toggleFeature(id, block) {
      this.$set(this.featureExpanded, `${id}:${block}`, !this.featureExpanded[`${id}:${block}`]);
    },
    // Copy nhanh ID/domain/IP cho admin (clipboard API + fallback execCommand)
    async copyText(text) {
      if (text === null || text === undefined || text === '') return;
      const str = String(text);
      try {
        await navigator.clipboard.writeText(str);
      } catch (e) {
        // Fallback trình duyệt cũ / không có quyền clipboard
        const ta = document.createElement('textarea');
        ta.value = str;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) { /* ignore */ }
        document.body.removeChild(ta);
      }
      this.$swal({
        toast: true, position: 'top-end', icon: 'success',
        title: this.$t('copied'), showConfirmButton: false, timer: 1200,
      });
    },
    // Số ngày còn lại tới mốc expireTime (làm tròn lên); <=0 nếu đã qua
    daysLeft(expireTime) {
      if (!expireTime) return null;
      return Math.ceil((expireTime - Date.now()) / (24 * 60 * 60 * 1000));
    },
    getPartnerDomains() {
      this.$bgService.get('/partner-domain', { params: { page: 1, pageSize: 500 } }).then(response => {
        this.partnerDomains = (response.data && response.data.docs) ? response.data.docs : [];
      }).catch(() => { /* ignore — select rỗng nếu lỗi */ });
    },
    // Tên domain đối tác của 1 client (populated object hoặc fallback tra trong list đã load)
    partnerDomainText(item) {
      const pd = item && item.partnerDomain;
      if (!pd) return '';
      if (typeof pd === 'object') return (pd.name || '') + (pd.domain ? ' (' + pd.domain + ')' : '');
      const found = this.partnerDomains.find(d => d._id === pd);
      return found ? found.name + ' (' + found.domain + ')' : '';
    },
    store() {
      return store
    },
    hasBrandCustomization(item) {
      return !!(item && item.brandCustomizationEnabled);
    },
    hasBrandData(item) {
      const b = item && item.brandCustomization;
      if (!b) return false;
      return !!(b.logo || b.favicon || b.primaryColor || b.secondaryColor || b.sidebarBgColor || b.headerBgColor);
    },
    goToKycRequest(id) {
      if (!id) return;
      this.$router.push({path: '/client/kyc-request', query: {open: id}});
    },
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    getPlans() {
      this.plans = [{
        value: null,
        text: this.$t('choosePlan')
      }];
      this.$bgService.get('/plan', {
        params: {
          page: 1,
          pageSize: 1000,
          status: 0,
          country: this.formModel.country
        }
      }).then(response => {
        let found = false;
        response.data.docs.forEach(item => {
          this.plans.push({
            value: item._id,
            text: item.name
          });
          if (item._id === this.formModel.plan) {
            found = true;
          }
        });
        if (!found) {
          this.formModel.plan = null;
        }
      });
    },
    getCount() {
      this.countLoading = true
      this.$service.get('/client/count', {params: this.filterFormModel})
          .then(response => {
            this.count = response.data;
          })
          .catch(() => {
            this.count = {};
          })
          .finally(() => {
            this.countLoading = false;
          });
    },
    getFistOrder() {
      if (!['sales', 'kpiSales'].includes(this.$store.state.user.role)) {
        let ids = this.items.map(item => item._id);
        this.$service.post('/client/first-plan-order', {ids}).then(response => {
          this.firstOrders = {};
          response.data.forEach(item => {
            this.firstOrders[item._id] = item;
          });
        });
      }
    },
    getTimezones() {
      this.timezoneOptions = [{
        value: null,
        text: this.$t('chooseTimezone')
      }];
      this.$bgService.get('/country/timezone/' + this.formModel.country).then(response => {
        let found = false;
        response.data.forEach(item => {
          this.timezoneOptions.push(item);
        });
        if (this.timezoneOptions.includes(this.formModel.timezone)) {
          found = true;
        }
        if (!found) {
          this.formModel.timezone = null;
        }
      })
    },
    getBusinessCategoryList() {
      this.categoryOptions = []
      this.$service.get('/category', {
        params: {
          page: 1,
          pageSize: 100,
          status: 0
        }
      }).then(response => {
        if (response && response.data) {
          response.data.docs.forEach(cat => {
            this.categoryOptions.push({value: cat._id, text: `${cat.code}. ${cat.name}`});
          })
        }
      })
    },
    getBusinessCategory(type) {
      let result = [this.$t('unknown')];
      if (type) {
        result = [];
        for (let category of type) {
          let cat = this.categoryOptions.find(c => c.value === category);
          if (cat) result.push(cat.text);
        }
      }
      return result.join(", ");
    },
    care(id) {
      this.$swal({
        icon: 'info',
        text: this.$t('careConfirm'),
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.post('/client/care/' + id).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: this.$t('careSuccess')
              })
              this.load();
            } else {
              this.$swal({
                icon: 'success',
                text: this.$t('careFailed')
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      })
    },
    demo(id) {
      this.$swal({
        icon: 'info',
        text: this.$t('demoConfirm'),
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.post('/client/demo/' + id).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: this.$t('updated')
              })
              this.load();
            } else {
              this.$swal({
                icon: 'success',
                text: this.$t('updateFailed')
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      })
    },
    mustHidden(item) {
      let hidden = false;
      if (['sales', 'kpiSales'].includes(this.$store.state.user.role) && (!item.sales || item.sales._id !== this.$store.state.user._id)) {
        hidden = true;
      }
      // if (this.$store.state.user.role === 'am' && (!item.account || item.account._id !== this.$store.state.user._id)) {
      //   hidden = true;
      // }
      if (['marketing'].includes(this.$store.state.user.role)) {
        hidden = true;
      }
      return hidden;
    },
    hidePhone: function (item) {
      if (item.phone) {
        return item.phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{4})(\d{3})/, '$1xxxx$3');
      }
    },
    hideEmail: function (item) {
      if (item.email) {
        return item.email.replace(/(.{2})(.*)(?=@)/,
            function (gp1, gp2, gp3) {
              for (let i = 0; i < gp3.length; i++) {
                gp2 += "*";
              }
              return gp2;
            });
      }
    },
    checkRole: function (roles) {
      return roles.includes(this.$store.state.user.role);
    },
    getMonthActivated(startTime, endTime) {
      let start = moment(startTime);
      let end = moment(endTime);

      return end.diff(start, 'months', true);
    }
  },
  watch: {
    "formModel.country": {
      handler() {
        if (this.formModel.country) {
          this.getPlans();
          this.getTimezones();
        } else {
          // this.plans = [{
          //   value: null,
          //   text: this.$t('chooseCountryFirst')
          // }];
          this.formModel.plan = null;
          this.timezoneOptions = [{
            value: null,
            text: this.$t('chooseCountryFirst')
          }];
          this.formModel.timezone = null;
        }
      }
    },
    "formModel.host": {
      handler(val) {
        let host = this.hosts.find(host => host._id == val);
        if (host && host.type === 'proxy') {
          this.currentHost = host;
        } else {
          this.currentHost = null;
        }
      }, deep: true
    },
  },
  i18n: {
    messages: {
      en: {
        host: 'Host',
        domain: 'Domain',
        companyName: 'Company name',
        plan: 'Plan',
        chooseCountryFirst: 'Choose a country first',
        choosePlan: 'Choose a plan',
        expireTime: 'Expired time',
        numberOfUser: 'Number of user',
        userLimit: 'User limit',
        userNumberLimit: 'Smartphone limit',
        creditLimit: 'Credit limit',
        storageLimit: 'Storage size per user (GB)',
        addedStorage: 'Added storage (GB)',
        totalStorage: 'Total storage limit (GB)',
        numberOfNumber: 'Number of number',
        numberOfSmartphone: 'Number of smartphone',
        clientInfo: 'Client info',
        subscribeInfo: 'Subscribe info',
        subscribeFeatureEnabled: 'Enabled features',
        subscribeFeatureNone: 'No feature enabled',
        featureOffSuffix: 'off',
        collapseFeature: 'Collapse',
        sourceOrganic: 'Organic',
        sourceSalesSelf: 'Sales self-sourced',
        sourceMarketing: 'Marketing',
        betaTesting: 'Beta testing',
        contractOverdue: 'Contract overdue',
        contractDaysLeft: '{days} day(s) left to sign contract',
        trialDaysLeft: 'Trial · {days}d left',
        copied: 'Copied',
        copyHint: 'Copy',
        noAccountWarning: 'No account assigned',
        groupStatus: 'Status',
        groupOwnership: 'Assigned to',
        groupInfra: 'Infrastructure',
        groupFinance: 'Plan & billing',
        groupFeature: 'Features',
        groupIdentity: 'Identity & Contact',
        groupRegistration: 'Registration',
        colStatusTitle: 'Status & Ownership',
        pipelineEnabled: 'Pipeline',
        multiChannelEnabled: 'Multi-channel',
        eventEnabled: 'Event',
        callCampaignEnabled: 'Call campaign',
        kpiEnabled: 'KPI',
        creditBalance: 'Credit Balance',
        yes: 'Yes',
        no: 'No',
        createDeposit: 'Create a deposit',
        na: 'Not available',
        isTrial: 'Trial',
        timezone: 'Timezone',
        chooseTimezone: 'Choose timezone',
        privatePlan: 'Private plan',
        userPrice: 'Price per user per month',
        expired: 'Expired',
        activating: 'Activating',
        locked: 'Locked',
        createTime: 'Create time',
        sales: 'Sale person',
        noSales: 'No pos person',
        account: 'Account',
        noAccount: 'No pos account',
        taxCode: 'Tax code',
        notUpdated: 'Not updated',
        source: 'Source',
        agency: 'Agency',
        partnerDomainAssign: 'Partner domain (login access)',
        partnerDomainNone: '— Not assigned —',
        partnerDomainAll: 'All partner domains',
        introducingAgent: 'Introducing agent',
        chooseSource: 'Choose source',
        chooseBD: 'Choose sales',
        chooseAM: 'Choose supporter',
        chooseAccount: 'Choose account',
        baseCallFee: 'Base call fee',
        monthlyUserPackage: 'Monthly user package',
        allowMultipleLogins: 'Allow multiple logins',
        allowDNC: 'Allow DNC',
        care: "Care",
        careConfirm: "Are you sure to care this client?",
        careSuccess: "Care client successfully!",
        careFailed: "Fail to care client",
        trialExtendRequest: "Trial extend request",
        filterByUserCount: "All user count",
        activeUser: 'Number of active user',
        userCountMin: 'Min user count',
        userCountMax: 'Max user count',
        mediaRelay: 'Media relay',
        updateAllUsers: 'Update all users',
        smsTemplateManageEnabled: 'SMS template self manage',
        isDemo: "Xác nhận demo",
        demo: "Demo",
        demoConfirm: "Are you sure to demo this client?",
        notCared: 'Not cared',
        averageDailyExpense: "Average daily expense",
        ssoEnabled: "Đăng nhập SSO, quên mật khẩu",
        firstOrderTime: "First order time",
        firstOrderValue: "First order value",
        firstOrderSale: "First order pos person",
        companySource: "Company source",
        selfFindingSource: "Self-finding source",
        isCDP: "CDP",
        careTime: "Care time",
        isKYC: "Confirm KYC",
        notKYC: 'Not KYC',
        lead: "Lead",
        useNeed: "Need",
        registerRole: "Role",
        companySize: "Company size",
        affiliate: "Affiliate",
        customerContactEnabled: "Customer contact enabled",
        manualInvoiceEnabled: "Xuất hoá đơn thủ công",
        subscribeEmail: "Subscribe email from Callio",
        affiliated: "Affiliated",
        aiEnabled: "Gọi tự động",
        orderEnabled: "Sản phẩm, kho vận, đơn hàng",
        ticketEnabled: 'Ticket',
        socialNetworkAccountLimit: "Giới hạn tài khoản mạng xã hội",
        numberLimit: "Giới hạn số điện thoại",
        automationWorkflowLimit: "Giới hạn quy trình tự động hoá",
        automationLimit: "Giới hạn tự động hoá",
        unlimitedIfEmpty: "Để trống = vô hạn",
        channelPrice: "Giá/kênh phát sinh",
        advancedNumber: "Số chức năng nâng cao",
        channelNumber: "Số kênh (Đa kênh, gọi thoại)",
        callEnabled: "Gọi thoại (Kênh)",
        integrationEnabled: "Tích hợp",
        performanceDiagnosticEnabled: "Chẩn đoán hiệu năng",
        evalCallEnabled: "Bật đánh giá cuộc gọi",
        evalChatEnabled: "Bật đánh giá tin nhắn",
        videoEnabled: "Gọi video nội bộ",
        videoCCUPrice: "Giá/1 CCU - Không ghi hình",
        videoRecordingPrice: "Giá/1 CCU - Có ghi hình",
        videoCCUNumber: "Số CCU miễn phí",
        phonebookEnabled: "Phone number directory",
        callUploadFileEnabled: "Cho phép thay đổi file ghi âm cuộc gọi",
        referralEnabled: "Cho phép ghi nhận chương trình giới thiệu",
        transcodeMedia: "Cho phép nén ghi âm trên RTP",
        multiplePipelineEnabled: "Cơ hội bán hàng dạng chiến dịch",
        offBuyNumber: "Khoá chức năng tự mua số điện thoại",
        clientCode: "Client code",
        isChatbot: "Use AI agent",
        chatbotTrialTime: "AI agent trial expiration time",
        chatbotExpireTime: "AI agent expiration time",
        enterChatbotTrialTime: "Enter the trial expiration time",
        enterChatbotExpireTime: "Enter the expiration time",
        aiAgentFreeTokenInitial: "Granted free tokens (total)",
        aiAgentFreeTokenRemaining: "Free tokens remaining",
        aiAgentFreeTokenHint: "Free tokens are granted once when the customer activates the AI agent. Adjust here to gift more.",
        aiAgentPackage: {
          title: "AI Token Subscription Package",
          hint: "Assign a fixed monthly package — caps token usage per period. Token surplus expires at period end.",
          package: "Package",
          noPackageOption: "— No package (pay-per-token) —",
          capToken: "Cap tokens / period",
          capTokenHint: "Reset to package default when subscribing. Add-on upgrades increase cap.",
          usedThisPeriod: "Used this period",
          usedHint: "Tổng (chat + QA). Reset đầu kỳ.",
          whenCapExhausted: "When cap exhausted",
          pause: "Pause",
          pauseHint: "AI stops replying until next period (cost control).",
          fallback: "Fallback to credit balance",
          fallbackHint: "AI keeps running, overflow charged from credit balance at 200k/1M (recommended).",
          nextReset: "Next reset",
          resetNote: "Reset is hourly via notification cron.",
          noPackage: "No subscription. Client pays per token from credit balance.",
        },
        gte12Months: "≥ 12 months",
        lt12Months: "< 12 months",
        activationTime: "Activation time",
        bigCustomer: "Big customer",
        isContractPaid: "Contract paid",
        pendingLockAfterActivated: "Waiting to be locked after activation",
        brandCustomization: {
          adminToggleLabel: "Allow brand customization",
          adminToggleHint: "When enabled, client owner can change logo, favicon and dashboard colors",
          preview: "Current brand preview",
          logo: "Logo",
          favicon: "Favicon",
          primaryColor: "Primary color",
          secondaryColor: "Secondary color",
          sidebarBgColor: "Sidebar background",
          headerBgColor: "Header background",
          updatedAt: "Last updated",
          updatedBy: "By",
          hasBrand: "Brand customized (has data)",
          allowedNotSetup: "Allowed but not setup yet",
          tabFilterTitle: "Brand customization allowed",
        },
      },
      vi: {
        host: 'Tổng đài',
        domain: 'Domain',
        companyName: 'Tên công ty',
        plan: 'Gói dịch vụ',
        chooseCountryFirst: 'Chọn quốc gia trước',
        choosePlan: 'Chọn gói dịch vụ',
        expireTime: 'Thời gian hết hạn',
        numberOfUser: 'Số user',
        userLimit: 'Giới hạn số user',
        userNumberLimit: 'Giới hạn số smartphone',
        creditLimit: 'Hạn mức tài khoản tối thiểu',
        storageLimit: 'Dung lượng lưu trữ / user (GB)',
        addedStorage: 'Dung lượng mua thêm (GB)',
        totalStorage: 'Tổng dung lượng lưu trữ (GB)',
        numberOfNumber: 'Số đầu số',
        numberOfSmartphone: 'Số smartphone',
        clientInfo: 'Thông tin khách',
        subscribeInfo: 'Thông tin gói cước',
        subscribeFeatureEnabled: 'Tính năng đang bật',
        subscribeFeatureNone: 'Chưa bật tính năng nào',
        featureOffSuffix: 'đang tắt',
        collapseFeature: 'Thu gọn',
        sourceOrganic: 'Tự nhiên',
        sourceSalesSelf: 'NVKD tự tìm',
        sourceMarketing: 'Marketing',
        betaTesting: 'Beta testing',
        contractOverdue: 'Quá hạn ký HĐ',
        contractDaysLeft: 'Còn {days} ngày cần ký HĐ',
        trialDaysLeft: 'Dùng thử · còn {days} ngày',
        copied: 'Đã sao chép',
        copyHint: 'Sao chép',
        noAccountWarning: 'Chưa gán chăm sóc',
        groupStatus: 'Trạng thái',
        groupOwnership: 'Phụ trách',
        groupInfra: 'Hạ tầng',
        groupFinance: 'Gói & Tài chính',
        groupFeature: 'Tính năng',
        groupIdentity: 'Định danh & Liên hệ',
        groupRegistration: 'Đăng ký',
        colStatusTitle: 'Trạng thái & Phụ trách',
        pipelineEnabled: 'Pipeline bán hàng',
        multiChannelEnabled: 'Đa kênh',
        eventEnabled: 'Lịch hẹn',
        callCampaignEnabled: 'Chiến dịch gọi điện',
        kpiEnabled: 'KPI',
        creditBalance: 'Số dư tài khoản',
        yes: 'Có',
        no: 'Không',
        createDeposit: 'Thêm lệnh nạp tiền',
        na: 'Không có',
        isTrial: 'Dùng thử',
        timezone: 'Múi giờ',
        chooseTimezone: 'Chọn múi giờ',
        privatePlan: 'Gói cước riêng',
        userPrice: 'Giá/user/tháng',
        expired: 'Hết hạn',
        trial: 'Đang dùng thử',
        trialExpiredSoon: 'Dùng thử sắp hết hạn',
        trialExpired: 'Dùng thử đã hết hạn',
        expiredSoon: 'Sắp hết hạn trong tháng',
        activating: 'Đang hoạt động',
        locked: 'Bị khoá',
        createTime: 'Tạo lúc',
        sales: 'Nhân viên sales',
        noSales: 'Chưa có nhân viên sales',
        account: 'Nhân viên account',
        noAccount: 'Chưa có nhân viên account',
        taxCode: 'Mã số thuế',
        notUpdated: 'Chưa cập nhật',
        source: 'Loại khách',
        agency: 'Đại lý / CTV',
        partnerDomainAssign: 'Domain đối tác (giới hạn đăng nhập)',
        partnerDomainNone: '— Không gán —',
        partnerDomainAll: 'Tất cả domain đối tác',
        introducingAgent: 'Đại lý giới thiệu',
        chooseSource: 'Chọn loại khách',
        chooseBD: 'Chọn sales',
        chooseAM: 'Chọn chăm sóc',
        chooseAccount: 'Chọn account',
        baseCallFee: 'Cước nền',
        monthlyUserPackage: 'Trọn gói tháng',
        allowMultipleLogins: 'Đăng nhập nhiều thiết bị',
        allowDNC: 'Cho phép gọi DNC',
        care: 'Nhận chăm sóc',
        careConfirm: "Bạn có chắc muốn nhận chăm sóc khách hàng này?",
        careSuccess: "Nhận chăm sóc thành công!",
        careFailed: "Nhận chăm sóc thất bại",
        trialExtendRequest: "Yêu cầu gia hạn dùng thử",
        filterByUserCount: "Tất cả số lượng user",
        activeUser: 'Số lượng user đang hoạt động',
        userCountMin: 'Từ giá trị',
        userCountMax: 'Đến giá trị',
        mediaRelay: 'Media relay',
        updateAllUsers: 'Cập nhật tất cả users',
        smsTemplateManageEnabled: 'Tự quản lý SMS Template',
        isDemo: "Xác nhận demo",
        demo: "Đã demo",
        demoConfirm: "Bạn có chắc muốn xác nhận đã demo cho khách hàng này?",
        notCared: 'Chưa được chăm sóc',
        averageDailyExpense: "Chi tiêu trung bình hàng ngày",
        ssoEnabled: "Đăng nhập SSO, quên mật khẩu",
        firstOrderTime: "Đơn hàng đầu tiên lúc",
        firstOrderValue: "Giá trị đơn hàng đầu tiên",
        firstOrderSale: "Sales đầu tiên",
        companySource: "Nguồn công ty",
        selfFindingSource: "Nguồn tự tìm",
        isCDP: "Kích hoạt CDP",
        careTime: "Thời gian chăm sóc",
        isKYC: "Xác nhận KYC",
        notKYC: 'Chưa xác thực',
        lead: "Tiềm năng",
        useNeed: "Nhu cầu",
        registerRole: "Vị trí người đăng ký",
        companySize: "Số lượng nhân viên",
        affiliate: "Giới thiệu",
        customerContactEnabled: "Sử dụng liên hệ trong hhách hàng",
        manualInvoiceEnabled: "Xuất hoá đơn thủ công",
        subscribeEmail: "Nhận email từ Callio",
        affiliated: "Được giới thiệu",
        aiEnabled: "Gọi tự động",
        orderEnabled: "Sản phẩm, kho vận, đơn hàng",
        ticketEnabled: 'Ticket',
        socialNetworkAccountLimit: "Giới hạn tài khoản mạng xã hội",
        numberLimit: "Giới hạn số điện thoại",
        automationWorkflowLimit: "Giới hạn quy trình tự động hoá",
        automationLimit: "Giới hạn tự động hoá",
        unlimitedIfEmpty: "Để trống = vô hạn",
        channelPrice: "Giá/kênh phát sinh",
        advancedNumber: "Số chức năng nâng cao",
        channelNumber: "Số kênh (Đa kênh, gọi thoại)",
        callEnabled: "Gọi thoại (Kênh)",
        integrationEnabled: "Tích hợp",
        performanceDiagnosticEnabled: "Chẩn đoán hiệu năng",
        evalCallEnabled: "Bật đánh giá cuộc gọi",
        evalChatEnabled: "Bật đánh giá tin nhắn",
        videoEnabled: "Gọi video nội bộ",
        videoCCUPrice: "Giá/1 CCU - Không ghi hình",
        videoRecordingPrice: "Giá/1 CCU - Có ghi hình",
        videoCCUNumber: "Số CCU miễn phí",
        phonebookEnabled: "Danh bạ số điện thoại",
        callUploadFileEnabled: "Cho phép thay đổi file ghi âm cuộc gọi",
        referralEnabled: "Cho phép ghi nhận chương trình giới thiệu",
        transcodeMedia: "Cho phép nén ghi âm trên RTP",
        multiplePipelineEnabled: "Cơ hội bán hàng dạng chiến dịch",
        offBuyNumber: "Khoá chức năng tự mua số điện thoại",
        clientCode: "Mã khách hàng",
        isChatbot: "Sử dụng nhân viên AI",
        chatbotTrialTime: "Thời gian hết hạn dùng thử nhân viên AI",
        chatbotExpireTime: "Thời gian hết hạn nhân viên AI",
        enterChatbotTrialTime: "Nhập thời gian hết hạn dùng thử",
        enterChatbotExpireTime: "Nhập thời gian hết hạn",
        aiAgentFreeTokenInitial: "Token miễn phí đã cấp (tổng)",
        aiAgentFreeTokenRemaining: "Token miễn phí còn lại",
        aiAgentFreeTokenHint: "Token miễn phí được cấp 1 lần khi khách kích hoạt nhân viên AI. Sửa ở đây để tặng thêm cho khách.",
        aiAgentPackage: {
          title: "Gói AI Token tháng",
          hint: "Gán gói cố định — token có hạn theo kỳ. Token dư cuối kỳ mất hết.",
          package: "Gói",
          noPackageOption: "— Không có gói (tính theo từng token) —",
          capToken: "Cap token / kỳ",
          capTokenHint: "Reset về mức gói khi subscribe. Upgrade add-on sẽ cộng thêm.",
          usedThisPeriod: "Đã dùng kỳ này",
          usedHint: "Tổng (chat + QA). Reset đầu kỳ.",
          whenCapExhausted: "Khi hết cap",
          pause: "Tạm dừng",
          pauseHint: "AI ngưng trả lời khách đến đầu kỳ sau. Phù hợp với doanh nghiệp muốn kiểm soát chi phí cứng.",
          fallback: "Tự động chuyển trừ số dư",
          fallbackHint: "AI vẫn chạy bình thường, phần vượt cap trừ vào Số dư tài khoản theo giá lẻ (200k/1M token). Khuyến nghị để không gián đoạn dịch vụ.",
          nextReset: "Kỳ tiếp theo bắt đầu",
          resetNote: "Reset kỳ chạy mỗi giờ qua notification cron.",
          noPackage: "Chưa subscribe gói. Khách trả tiền theo token từ số dư tài khoản.",
        },
        gte12Months: "≥ 12 tháng",
        lt12Months: "< 12 tháng",
        activationTime: "Thời gian kích hoạt",
        bigCustomer: "Khách hàng lớn",
        isContractPaid: "Đã trả hợp đồng",
        pendingLockAfterActivated: "Chờ khoá sau kích hoạt",
        brandCustomization: {
          adminToggleLabel: "Cho phép tuỳ biến nhận diện thương hiệu",
          adminToggleHint: "Khi bật, owner client có thể tự thay logo, favicon và màu sắc dashboard",
          preview: "Xem trước nhận diện hiện tại",
          logo: "Logo",
          favicon: "Icon trình duyệt",
          primaryColor: "Màu chính",
          secondaryColor: "Màu phụ",
          sidebarBgColor: "Màu nền sidebar",
          headerBgColor: "Màu nền thanh tiêu đề",
          updatedAt: "Cập nhật lần cuối",
          updatedBy: "Bởi",
          hasBrand: "Đã tuỳ biến nhận diện (có data)",
          allowedNotSetup: "Đã cho phép tuỳ biến (chưa setup)",
          tabFilterTitle: "Cho phép tuỳ biến brand",
        },
      }
    }
  }
};
</script>

<style>
.badge-pink {
  background-color: hotpink;
  color: white;
}

.badge-blue {
  background-color: blue;
  color: white;
}
</style>